import React from 'react';
import * as Yup from 'yup';
import { CheckboxWithLabel, SubmitButton, useAlert } from '@uplift/ui-v2';
import { CollaborativeAgreementSigned } from '@uplift/api';
import { useCollaboratePhysicianMatchByIdForPhysicianQuery, useCounterSignCollaborativeAgreementMutation, useUserDisplayNameQuery } from '@uplift/queries';
import { Box, Divider, Paper, Typography } from '@mui/material';
import { Formik } from 'formik';
import { useCurrentuser } from '@uplift/contexts';


export const CounterSignDocumentControls: React.VFC<{
  document: CollaborativeAgreementSigned;
  onSign: (agreementId: string) => void;
}> = ({ document, onSign }) => {
  const me = useCurrentuser();
  const { data: match } = useCollaboratePhysicianMatchByIdForPhysicianQuery(me.id, document.collaborativeMatchId);
  const { data: providerName } = useUserDisplayNameQuery(match.providerId, { suspense: true });
  const { data: physicianName } = useUserDisplayNameQuery(match.collaborativePhysicianId, { suspense: true });
  const counterSignMutation = useCounterSignCollaborativeAgreementMutation(me.id);
  const alert = useAlert();

  return (
    <Formik
      initialValues={{ fullLegalName: providerName.full, agree: false }}
      validationSchema={Yup.object().shape({
        agree: Yup.boolean().oneOf([ true ], 'You must agree to sign the agreement'),
      })}
      onSubmit={async () => {
        const counterSignedAgreementId = await counterSignMutation.mutateAsync({
          signedAgreementId: document.id,
        });

        onSign(counterSignedAgreementId);
        alert.success('Successfully counter-signed the agreement');
      }}
    >
      <Box>
        <Divider />
        <Box sx={{ p: 3, pt: 2, display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          <Box>
            <Typography variant="overline" color="secondary">Nurse Practitioner</Typography>
            <Paper variant="outlined" sx={{ p: 1.5 }}>
              <Typography>
                {providerName.fullLegalName}
              </Typography>
            </Paper>
          </Box>
          <Box>
            <Typography variant="overline" color="secondary">Your Counter-Signature</Typography>
            <Paper variant="outlined" sx={{ p: 1.5 }}>
              <Typography>
                {physicianName.fullLegalName}
              </Typography>
            </Paper>
          </Box>
          <CheckboxWithLabel showError name="agree" label="By checking this, I confirm I am the Collaborating Physician named in this agreement and agree this constitutes my legal electronic counter-signature." />
          <Box>
            <SubmitButton>Sign agreement</SubmitButton>
          </Box>
        </Box>
      </Box>
    </Formik>
  );
};
